import { faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, Route, Switch, useLocation } from 'react-router-dom';
import { Col, Container, ListGroup, ListGroupItem, Row } from 'reactstrap';
import { actions } from '../../../context';
import Account from './Account';
import { Facebook } from 'react-spinners-css';
import classNames from 'classnames';
import NewAccountModal from './NewAccountModal';
import NewButton from '../Shared/NewButton';

const Accounts = () => {
    const loc = useLocation();
    const dispatch = useDispatch();
    const [accounts, setAccounts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [newAccount, setNewAccount] = useState(false);

    const toggleNew = useCallback(() => setNewAccount(!newAccount), [newAccount]);

    const refresh = useCallback(() =>
        dispatch(actions.accounts.getAccounts())
            .then((res) => setAccounts(res || []))
            .then(() => setLoading(false)), [dispatch]);

    useEffect(() => {
        setLoading(true);
        refresh();
        // eslint-disable-next-line
    }, [dispatch]);

    return (
        <>
            <NewAccountModal
                isOpen={newAccount}
                toggle={toggleNew}
                refresh={refresh}
            />
            <Container>
                <Row className="text-white">
                    <Col lg="3">
                        <div className="d-flex justify-content-between">
                            <h2>
                                <FontAwesomeIcon icon={faUser} />
                                &emsp;Accounts
                            </h2>
                            <div>
                                <NewButton
                                    noSpaces
                                    id="newAccount"
                                    title="Create new account"
                                    onClick={toggleNew}
                                />
                            </div>
                        </div>
                        {loading ? (
                            <h2 className="m-4 text-center">
                                <Facebook color="#eee" />
                            </h2>
                        ) : (
                            <ListGroup
                                style={{
                                    maxHeight: '80vh',
                                    overflowY: 'scroll',
                                }}>
                                {accounts.map((a, x) => (
                                    <div
                                        key={a.id}
                                        className={classNames({
                                            'text-dark': !loc.pathname.includes(
                                                a.id
                                            ),
                                        })}>
                                        <Link
                                            to={`/admin/accounts/${a.id}`}
                                            style={{ textDecoration: 'none' }}>
                                            <ListGroupItem
                                                action
                                                active={loc.pathname.includes(
                                                    a.id
                                                )}>
                                                <div>
                                                    {a.firstName}&nbsp;
                                                    {a.lastName}
                                                </div>
                                                <div className="text-12 op-8">
                                                    {a.email}
                                                </div>
                                            </ListGroupItem>
                                        </Link>
                                    </div>
                                ))}
                            </ListGroup>
                        )}
                    </Col>
                    <Col lg="9">
                        <Switch>
                            <Route path="/admin/accounts/:accountId">
                                <Account refreshAccounts={refresh} />
                            </Route>
                        </Switch>
                    </Col>
                </Row>
            </Container>
            <div></div>
        </>
    );
};

export default Accounts;
